// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:480px){.yappli-footer-menu[data-v-806f8c3e]{position:fixed;z-index:800;bottom:0;width:100%}.yappli-footer-menu .yappli-btn[data-v-806f8c3e]{background-color:#fff;width:66px;height:66px;border-radius:10px;position:absolute;left:2.5%;bottom:9px;border:1px solid #000}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
